import moment from 'moment';
import { isNullOrBlank } from '../../utils/checker';

const boldBackgroundColor = '#cacbcc';

const riskLevels = [
	{ label: 'Level 0', value: 'LEVEL_0', level: 'Level 0', code: '0.00', score: '', status: 'No business', boxBg: '#5A8F3D', textColor: 'black' },
	{
		label: 'Level 1',
		value: 'LEVEL_1',
		level: 'Level 1',
		code: '1.00',
		score: '> 0, <= 1',
		status: 'No concerns/Minimal',
		boxBg: '#B3B34A',
		textColor: 'black',
	},
	{ label: 'Level 2', value: 'LEVEL_2', level: 'Level 2', code: '2.00', score: '> 1, <= 2', status: 'Some Concerns', boxBg: '#F4CF62', textColor: 'black' },
	{
		label: 'Level 3',
		value: 'LEVEL_3',
		level: 'Level 3',
		code: '3.00',
		score: '> 2, <= 3',
		status: 'Significant Concerns',
		boxBg: '#F28E5E',
		textColor: 'black',
	},
	{ label: 'Level 4', value: 'LEVEL_4', level: 'Level 4', code: '4.00', score: '> 3', status: 'High Priority', boxBg: '#E45A4F', textColor: 'black' },
];

function getCompanyTypes(input) {
	const totalIndustryTypes = ['GENERAL_INSURANCE', 'LIFE_INSURANCE', 'MICRO_INSURANCE'];
	if (input === '1') {
		return totalIndustryTypes;
	} else if (input === '2') {
		return ['GENERAL_INSURANCE'];
	} else if (input === '3') {
		return ['LIFE_INSURANCE'];
	} else if (input === '4') {
		return ['MICRO_INSURANCE'];
	} else if (input === '5') {
		return ['REINSURANCE'];
	}
	return totalIndustryTypes;
}

function getFilterTitle({ title, industrial }) {
	if (title === '1') {
		return industrial === true ? 'Total Industry' : 'Total Ews';
	} else if (title === '2') {
		return 'General Insurance';
	} else if (title === '3') {
		return 'Life Insurance';
	} else if (title === '4') {
		return 'Micro Insurance';
	} else if (title === '5') {
		return 'ReInsurance';
	}
	return '';
}

function getYear(input) {
	moment.locale('en-gb');
	return parseInt(input ? input : moment().format('YYYY'));
}

function makeBoldCells(labels = [], cells = []) {
	if (labels?.length !== cells?.length) return cells;
	const boldRows = labels?.map((label, i) => (label?.readOnly === true ? i : -1))?.filter((i) => i !== -1);
	const localCells = cells.map((row, rowIndex) => {
		return row.map((cell, colIndex) => {
			const isBoldRow = boldRows?.includes(rowIndex);
			const isDataValue = false === isNullOrBlank(cell?.value);
			const isLabelValue = false === isNullOrBlank(labels[rowIndex]?.titleKhmer) && false === isNullOrBlank(labels[rowIndex]?.titleEnglish);
			return {
				...cell,
				className: cell?.className ? cell?.className : isBoldRow && (isDataValue || isLabelValue) ? 'highlighted-row' : '',
			};
		});
	});
	return localCells;
}

export { boldBackgroundColor, getCompanyTypes, getFilterTitle, getYear, riskLevels, makeBoldCells };
